import React from "react";
import "./css/services.css";
import "./css/responsive_services.css";
import { Grid } from "@mui/material";
import BannerReusable from "../../components/banner/BannerReusable";
import services_banner_image from "../../assets/banners/services_banner.jpg";
import architectural_design from "../../assets/banners/architectural_design.jpg";

import ServicesCard from "../../components/cards/ServicesCard";

// utils
import { cardDetails } from "../../components/utils/CardUtils";
import NavHook from "../../components/navigationbar/hooks/NavHook";
import DialogReusable from "../../components/dialog/DialogReusable";
import { useSelector } from "react-redux";

const ServicesPage = () => {
  const { ...param } = NavHook();
  const reducer_data = useSelector((state) => state.GlobalReducer);

  return (
    <>
      <Grid
        container
        columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
        columnSpacing={{ xs: 1, sm: 2, md: 3, lg: 3 }}
        rowSpacing={1}
        justifyContent="center"
      >
        {/* banner section of the services page */}
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <BannerReusable
            banner_image={architectural_design}
            tagline="modern design"
            handleDialog={param.handleDialogOpen}
          />{" "}
          <DialogReusable
            isDialogOpen={param.isDialogOpen}
            onClose={param.handleDialogClose}
            onChangeText={(e, objectKey) => param.onChangeText(e, objectKey)}
            reducer_data={reducer_data}
            handleSubmit={param.handleSubmit}
          />
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Grid
            container
            columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
            columnSpacing={{ xs: 1, sm: 1, md: 1, lg: 1 }}
            rowSpacing={{ xs: 2, sm: 2, md: 1, lg: 1 }}
            justifyContent="center"
            p={2}
          >
            <Grid item xs={12} sm={12} md={6} lg={11}>
              <div className="fs-text-content">
                {/* <p>FEATURED SERVICES</p> */}
                <h1>Featured Services</h1>
                <p>
                  Our featured services offer a comprehensive approach to the
                  entire lifecycle of a project, starting with pre-construction
                  planning where we meticulously analyze and strategize to
                  optimize your project's success.
                </p>
              </div>
            </Grid>

            {/* services card section */}
            {cardDetails.map((item, index) => (
              <Grid item xs={12} sm={11} md={3} lg={3} key={index}>
                <ServicesCard icon={item.icon} title={item.title} />
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default ServicesPage;
